import { render, staticRenderFns } from "./formDyn.vue?vue&type=template&id=0c1313e1"
import script from "./formDyn.vue?vue&type=script&lang=js"
export * from "./formDyn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports